<template>
<v-container>
    <v-row no-gutters>
        <v-col
            cols="12"
            md="4"
            sm="4"
        >
            <h1>Batches</h1>
        </v-col>
        <v-col
            cols="12"
            md="4"
            sm="4"
        >
            <v-switch
              v-model="gmwswitch"
              color="red"
              label="GMW"
              hide-details
            ></v-switch>
        </v-col>
        
        <v-spacer></v-spacer>
        <v-btn color="success" @click="createform()" >
            New Batch
        </v-btn>
    </v-row>
    <v-data-table
        :headers="headers"
        :items="filteredBatches"
    >   
        <template v-slot:thead>
            <tr>
                <td>
                    <v-text-field v-model="productsearch" class="ma-2" density="compact" placeholder="Product name..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="batchsearch" class="ma-2" density="compact" placeholder="Batch name..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="mfgdatesearch" class="ma-2" density="compact" placeholder="MFG Date..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="expdatesearch" class="ma-2" density="compact" placeholder="Exp Date..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="mrpsearch" class="ma-2" density="compact" placeholder="MRP..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="ratesearch" class="ma-2" density="compact" placeholder="Rate..." hide-details></v-text-field>
                </td>
            </tr>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-icon
                class="me-2"
                size="small"
                @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
        </template>
    </v-data-table>
    <div v-if="showForm">
        <Form :showForm="showForm" :editedItem="editedItem" :editedIndex="editedIndex" :updateIDGM="updateIDGM" :updateIDGMW="updateIDGMW" :gmwswitch="gmwswitch" @closedialog="closedialog"/>
    </div>
    
    <div v-if="showMessage">
        <ShowError @closesnackbar="closesnackbar"/>
    </div>
</v-container>

</template>

<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount, watch } from 'vue'
    import { useAuthStore } from '@/stores/AuthStore'
    import { useBatchStore } from '@/stores/BatchStore'
    import BatchService from '@/services/BatchService'
    import Form from '@/views/batches/form'
    import ShowError from '@/components/Showerror'
    import router from '@/router'

    const authStore = useAuthStore()
    const batchStore = useBatchStore()
    var batches = ref([])
    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')
    var productsearch = ref('')
    var batchsearch = ref('')
    var mfgdatesearch = ref('')
    var expdatesearch = ref('')
    var mrpsearch = ref('')
    var ratesearch = ref('')
    var showForm=ref(false)
    var editedIndex = ref(-1)
    var editedItem = ref({
        productname : '',
        batchno: '',
        mfgdate: '',
        mrp: '',
        rate: ''
    })
    var updateID = ref(-1)
    var updateIDGM = ref(-1)
    var updateIDGMW = ref(-1)
    var gmwswitch = ref(authStore.gmswitch)
    var gmbatches = ref([])
    var gmwbatches = ref([])

    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    //var batch = await getbatches()

    //console.log("This is from setup")
    //console.log(batches.value)

    var headers = ref([
        {
          title: 'Product Name',
          align: 'start',
          sortable: true,
          key: 'productname',
        },
        { title: 'Batch No', key: 'batchno' },
        { title: 'Mfg Date', key: 'mfgdate' },
        { title: 'Exp Date', key: 'expdate' },
        { title: 'MRP', key: 'mrp' },
        { title: 'Rate', key: 'rate' },
        { title: 'Actions', key: 'actions', sortable: false },
    ])

    onBeforeMount(async () => {
        var gmbatches = await getbatchesfromgm()
        var gmwbatches = await getbatchesfromgmw()
        batches.value = gmwswitch.value ? gmwbatches : gmbatches
    })

    const filteredBatches = computed(() => {
        var conditions = []

        if(productsearch.value){
            conditions.push(filterProductname)
        }
        if(batchsearch.value){
            conditions.push(filterBatchno)
        }

        if(mfgdatesearch.value){
            conditions.push(filterMfgDate)
        }

        if(expdatesearch.value){
            conditions.push(filterExpDate)
        }

        if(expdatesearch.value){
            conditions.push(filterExpDate)
        }

        if(mrpsearch.value){
            conditions.push(filterMrp)
        }

        if(ratesearch.value){
            conditions.push(filterRate)
        }

        if(conditions.length > 0){
            return batches.value.filter((batch) => {
                return conditions.every((condition) => {
                    return condition(batch)
                })
            })
        }

        return batches.value
    })

    onMounted(async () => {
    })

    async function getbatchesfromgm(){
        try{
            var batches = (await BatchService.getall()).data
            gmbatches.value = batches
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }

        try{
            await batchStore.setGMBatches(batches)
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = "Error in setting gm batches"
        }
        
        return batches
        
    }

    async function getbatchesfromgmw(){
        try{
            var batches = (await BatchService.getallgmw()).data
            gmwbatches.value = batches
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }

        try{
            await batchStore.setGMWBatches(batches)
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = "Error in setting gm batches"
        }
        
        return batches
    }

    watch(gmwswitch, async(val)=>{
        authStore.setGmswitch()
        batches.value = gmwswitch.value ? gmwbatches.value : gmbatches.value
    })

    function createform(){
        showForm.value = true
        console.log(showForm.value)
    }


    function closesnackbar (){
        showMessage.value = false
    }

    function closedialog (){
        showForm.value = false
        router.go(0)
    }

    function editItem(item) {
        if(gmwswitch.value){
            updateIDGMW.value = item.itemid
            var newArrayGM = gmbatches.value.filter(function (el) {
            return el.productname == item.productname &&
                    el.batchno == item.batchno;
            })
            updateIDGM.value = newArrayGM.length > 0 ? newArrayGM[0].itemid : -1
            console.log("filtered array GM")
            console.log(newArrayGM)
            console.log("Item ID of GM")
            console.log(updateIDGM.value)
            console.log("Item ID of GMW "+updateIDGMW.value)
        }else{
            updateIDGM.value = item.itemid
            var newArrayGMW = gmwbatches.value.filter(function (el) {
            return el.productname == item.productname &&
                    el.batchno == item.batchno;
            })
            updateIDGMW.value = newArrayGMW.length > 0 ? newArrayGMW[0].itemid : -1
            console.log("filtered array GMW")
            console.log(newArrayGMW)
            console.log("Item ID of GMW")
            console.log(updateIDGMW.value)
            console.log("Item id of GM "+updateIDGM.value) 
        }
        editedIndex.value = batches.value.indexOf(item)
        editedItem.value = Object.assign({}, item)
        updateID.value = item.itemid
        showForm.value = true
    }

    

    function deleteItem(item) {
        console.log(item)
    }

    function filterProductname(item){
        return item.productname.toLowerCase().includes(productsearch.value.toLowerCase())
    }

    function filterBatchno(item){
        return item.batchno.toLowerCase().includes(batchsearch.value.toLowerCase())
    }

    function filterMfgDate(item){
        return item.mfgdate.toLowerCase().includes(mfgdatesearch.value.toLowerCase())
    }

    function filterExpDate(item){
        return item.expdate.toLowerCase().includes(expdatesearch.value.toLowerCase())
    }

    function filterMrp(item){
        return item.mrp >= mrpsearch.value
    }

    function filterRate(item){
        return item.rate >= ratesearch.value
    }

</script>
